import React from "react";
import { Modal, Descriptions } from "antd";
import { getModalDims } from "../LedgerResponsive";

export default function SchemeModal({ open, record, onClose, screens, modalDims }) {
  if (!record) return null;

  const dims = modalDims || getModalDims(screens);

  return (
    <Modal
      title="Scheme Details"
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      maskClosable={false}
      keyboard={true}
      width={520}  // <-- Set fixed width
  bodyStyle={{ maxHeight: "70vh", overflowY: "auto", padding: 16 }}
  centered
>
      <Descriptions column={1} size="small" bordered>
        <Descriptions.Item label="Scheme Code">{record.scheme_code}</Descriptions.Item>
        <Descriptions.Item label="Scheme Name">{record.scheme_name}</Descriptions.Item>
        <Descriptions.Item label="Total Investment">₹{Number(record.total_investment || 0).toLocaleString()}</Descriptions.Item>
        <Descriptions.Item label="Redemption Cost Amount">₹{Number(record.redemption_cost_amount || 0).toLocaleString()}</Descriptions.Item>
        <Descriptions.Item label="Redemption Actual Amount">₹{Number(record.redemption_actual_amount || 0).toLocaleString()}</Descriptions.Item>
        <Descriptions.Item label="Remaining Cost Value">₹{Number(record.remaining_cost_amount || 0).toLocaleString()}</Descriptions.Item>
        <Descriptions.Item label="Current Value">₹{Number(record.current_value || 0).toLocaleString()}</Descriptions.Item>
      </Descriptions>
    </Modal>
  );
}
